// Auto-generated code snippets for Custom API integrations

export function getCodeSnippet(lang, apiKey, apiUrl, apiFields, defaultApiFields) {
  const fields = apiFields.length > 0 ? apiFields : defaultApiFields;
  const standardFields = fields.filter(f => f.map_to !== "custom");
  const customFields = fields.filter(f => f.map_to === "custom");
  const bodyFields = standardFields.map(f => `      ${f.map_to}: formData.${f.variable_name}`).join(',\n');
  const customFieldsCode = customFields.length > 0 ? `,\n      custom_fields: {\n${customFields.map(f => `        "${f.label}": formData.${f.variable_name}`).join(',\n')}\n      }` : '';

  const snippets = {
    javascript: `// POMEN Lead Tracker - Registration Form Integration
async function submitLead(formData) {
  const response = await fetch('${apiUrl}', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': '${apiKey}'
    },
    body: JSON.stringify({
${bodyFields}${customFieldsCode}
    })
  });
  return await response.json();
}

// Usage with your form:
document.getElementById('registrationForm').addEventListener('submit', async (e) => {
  e.preventDefault();
  const formData = {
${fields.map(f => `    ${f.variable_name}: document.getElementById('${f.variable_name}').value`).join(',\n')}
  };
  const result = await submitLead(formData);
  if (result.success) alert('Registration successful!');
});`,
    curl: `curl -X POST '${apiUrl}' \\
  -H 'Content-Type: application/json' \\
  -H 'X-API-Key: ${apiKey}' \\
  -d '{
${standardFields.map(f => `    "${f.map_to}": "value_for_${f.variable_name}"`).join(',\n')}${customFields.length > 0 ? `,\n    "custom_fields": {\n${customFields.map(f => `      "${f.label}": "value"`).join(',\n')}\n    }` : ''}
  }'`,
    python: `import requests

def submit_lead(${fields.map(f => f.variable_name).join(', ')}):
    payload = {
${standardFields.map(f => `        '${f.map_to}': ${f.variable_name}`).join(',\n')}${customFields.length > 0 ? `,\n        'custom_fields': {\n${customFields.map(f => `            '${f.label}': ${f.variable_name}`).join(',\n')}\n        }` : ''}
    }
    response = requests.post('${apiUrl}', headers={'Content-Type': 'application/json', 'X-API-Key': '${apiKey}'}, json=payload)
    return response.json()

# Usage
submit_lead(${fields.map(() => `'example'`).join(', ')})`,
    php: `<?php
function submitLead(${fields.map(f => '$' + f.variable_name).join(', ')}) {
    $data = [
${standardFields.map(f => `        '${f.map_to}' => $${f.variable_name}`).join(',\n')}${customFields.length > 0 ? `,\n        'custom_fields' => [\n${customFields.map(f => `            '${f.label}' => $${f.variable_name}`).join(',\n')}\n        ]` : ''}
    ];
    $ch = curl_init('${apiUrl}');
    curl_setopt($ch, CURLOPT_POST, true);
    curl_setopt($ch, CURLOPT_POSTFIELDS, json_encode($data));
    curl_setopt($ch, CURLOPT_HTTPHEADER, ['Content-Type: application/json', 'X-API-Key: ${apiKey}']);
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
    return json_decode(curl_exec($ch), true);
}
?>`
  };
  return snippets[lang] || snippets.javascript;
}

export function getSubscriptionSnippet(lang, apiKey, apiUrl) {
  const subUrl = apiUrl.replace("/v1/leads", "/v1/subscription");
  const snippets = {
    javascript: `// POMEN Lead Tracker - ENGARAGE Subscription Module Integration
// Embed this in your ENGARAGE subscription confirmation flow

async function notifySubscription(workshopId, email, plan, subscriberName, company, subscriptionId) {
  const response = await fetch('${subUrl}', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': '${apiKey}'
    },
    body: JSON.stringify({
      workshop_id: workshopId,
      email: email,
      plan: plan,               // "Basic", "Plus", or "Pro"
      subscriber_name: subscriberName,
      company: company,
      subscription_id: subscriptionId,
      subscription_date: new Date().toISOString()
    })
  });
  return await response.json();
}

// Usage: call after successful ENGARAGE subscription
// notifySubscription('WS-001', 'user@example.com', 'Pro', 'John Doe', 'ACME Inc', 'sub_12345');`,
    curl: `curl -X POST '${subUrl}' \\
  -H 'Content-Type: application/json' \\
  -H 'X-API-Key: ${apiKey}' \\
  -d '{
    "workshop_id": "WS-001",
    "email": "user@example.com",
    "plan": "Pro",
    "subscriber_name": "John Doe",
    "company": "ACME Inc",
    "subscription_id": "sub_12345",
    "subscription_date": "2026-01-15T00:00:00Z"
  }'`,
    python: `import requests
from datetime import datetime

def notify_subscription(workshop_id, email, plan, subscriber_name='', company='', subscription_id=''):
    """Call this after successful ENGARAGE subscription"""
    payload = {
        'workshop_id': workshop_id,
        'email': email,
        'plan': plan,               # "Basic", "Plus", or "Pro"
        'subscriber_name': subscriber_name,
        'company': company,
        'subscription_id': subscription_id,
        'subscription_date': datetime.utcnow().isoformat() + 'Z'
    }
    response = requests.post(
        '${subUrl}',
        headers={'Content-Type': 'application/json', 'X-API-Key': '${apiKey}'},
        json=payload
    )
    return response.json()

# Usage: call after successful ENGARAGE subscription
# notify_subscription('WS-001', 'user@example.com', 'Pro', 'John Doe', 'ACME Inc', 'sub_12345')`,
    php: `<?php
function notifySubscription($workshopId, $email, $plan, $subscriberName = '', $company = '', $subscriptionId = '') {
    $data = [
        'workshop_id' => $workshopId,
        'email' => $email,
        'plan' => $plan,               // "Basic", "Plus", or "Pro"
        'subscriber_name' => $subscriberName,
        'company' => $company,
        'subscription_id' => $subscriptionId,
        'subscription_date' => date('c')
    ];
    $ch = curl_init('${subUrl}');
    curl_setopt($ch, CURLOPT_POST, true);
    curl_setopt($ch, CURLOPT_POSTFIELDS, json_encode($data));
    curl_setopt($ch, CURLOPT_HTTPHEADER, ['Content-Type: application/json', 'X-API-Key: ${apiKey}']);
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
    return json_decode(curl_exec($ch), true);
}
?>`
  };
  return snippets[lang] || snippets.javascript;
}
